import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { HotToastService } from '@ngneat/hot-toast';

import { ProductDto } from 'src/app/core/dtos/dto';
import { SEE_INSIDE_ICONE_URL } from 'src/app/core/constants/constants';
import { ConfigHelper } from 'src/app/core/services/helpers/config.helper';
import { ProductModalComponent } from '../product-modal/product-modal.component';
import { ProductPreviewComponent } from '../product-preview/product-preview.component';
import { BrandEnum, ProductTypeEnum } from 'src/app/core/dtos/enum';
import { select, Store } from '@ngrx/store';
import { selectIsBusinessAccount } from 'src/app/state/my-account.selectors';
import { ProductService } from 'src/app/core/services/product.service';

@Component({
  selector: 'app-product-item',
  templateUrl: './product-item.component.html',
  styleUrls: ['./product-item.component.scss']
})
export class ProductItemComponent implements OnInit, OnDestroy {

  @Input() product: ProductDto;
  @Input() isRegFlow: boolean;
  @Input() brandId: BrandEnum;
  @Input() selectedSortOrder: number;
  @Output() addProduct: EventEmitter<ProductDto> = new EventEmitter();

  businessAccountSubscription: Subscription;
  downloadPdfSubscription: Subscription;
  seeInsideIconUrl: string;
  ProductEBookId = ProductTypeEnum.ElectronicProductEBook;
  isBusinessAccount: boolean;
  productShortDescription: string;

  constructor(
    private modalService: NgbModal,
    private configHelper: ConfigHelper,
    private store: Store,
    private productService: ProductService,
    private toastService: HotToastService
  ) { }

  public get BrandEnum() {
    return BrandEnum;
  }

  ngOnInit(): void {
    this.businessAccountSubscription = this.store.pipe(select(selectIsBusinessAccount))
      .subscribe((result) => {
        this.isBusinessAccount = result;
      });
    this.seeInsideIconUrl = this.configHelper.getImageUrl(SEE_INSIDE_ICONE_URL);
    this.productShortDescription = this.removeInlineStyleProductDescription(this.product.shortDescription);
  }

  onAdd = (product: ProductDto) => {
    this.addProduct.emit(product);
  };

  onModalLoad(product: ProductDto) {
    if (this.modalService.hasOpenModals) {
      this.modalService.dismissAll();
    }
    const modalRef = this.modalService.open(ProductModalComponent, { size: 'lg' });
    modalRef.componentInstance.product = product;
    modalRef.componentInstance.brandId = this.brandId;
    modalRef.componentInstance.isRegFlow = this.isRegFlow;
    modalRef.componentInstance.isBusinessAccount = this.isBusinessAccount;
    modalRef.componentInstance.addItem.subscribe((i) => this.onAdd(i));
    modalRef.componentInstance.download.subscribe((i) => this.downloadPdf(i));
  }

  showPreview(product: ProductDto) {
    const modalRef = this.modalService.open(ProductPreviewComponent, { size: 'lg' });
    modalRef.componentInstance.product = product;
    modalRef.componentInstance.isBusinessAccount = this.isBusinessAccount;
    modalRef.componentInstance.isRegFlow = this.isRegFlow;
    modalRef.componentInstance.addItem.subscribe((i) => this.onAdd(i));
    modalRef.componentInstance.download.subscribe((i) => this.downloadPdf(i));
  }

  downloadPdf(product: ProductDto) {
    this.downloadPdfSubscription = this.productService.downloadProductPdf(product.name)
      .subscribe(
        res => {
          const dataType = res.type;
          const blob = new Blob([res], { type: dataType });
          const data = window.URL.createObjectURL(blob);
          const downloadLink = document.createElement('a');
          downloadLink.href = data;
          downloadLink.setAttribute('download', product.name);
          downloadLink.click();
        },
        () => {
          this.toastService.warning('Unable to download the pdf');
        }
      );
  }

  removeInlineStyleProductDescription(productDescription: string) {
    //this will remove all inline styling from the product description
    productDescription = productDescription.replace(new RegExp('style="(.*?)"', 'g'), "");
    productDescription = productDescription.replace(new RegExp('face="(.*?)"', 'g'), "");
    return productDescription;
  }

  ngOnDestroy(): void {
    this.businessAccountSubscription?.unsubscribe();
    this.downloadPdfSubscription?.unsubscribe();
  }

}

